module.exports = __webpack_public_path__ + "img/advantage1@2x.4f775c97.png";